import React, { type FC } from 'react';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { NoAccessItem } from 'reactApp/ui/DataListItemRow/components/NoAccessItem/NoAccessItem';

interface ItemDestinationProps {
    id: string;
    name: string;
    ext?: string;
    isAccessDenied: boolean;
    renameAvailable?: boolean;
    storage: EStorageType;
}

export const Name: FC<ItemDestinationProps> = ({ id, name, ext, isAccessDenied, renameAvailable, storage }) => {
    if (isAccessDenied) {
        return <NoAccessItem />;
    }

    return <ItemName name={name} ext={ext || ''} id={id} isRenameAvailable={renameAvailable} storage={storage} saveFormatting />;
};
